<template>
<div class="card">
  <div class="card-content" style="padding-bottom: 0.5em;">
    <div class="media" style="margin-bottom:0.5rem;">
      <div class="media-left">
        <figure class="image is-32x32">
          <img :src="tweet_info.user.icon" alt="icon" class="is-rounded">
        </figure>
      </div>
      <div class="media-content">
        <span class="title is-6" style="margin-right: 0.2em;">{{tweet_info.user.name}}</span>
        <span class="subtitle is-7">@{{tweet_info.user.screen_name}}</span>
      </div>
      <div class="media-right">
        <a :href="'https://twitter.com/hoge/status/'+tweet_info.id" target="_blank">
          <b-icon icon="twitter" type="is-info"></b-icon>
        </a>
      </div>
    </div>
    <div class="content">
      <div class="tweettext" v-html="tweet_text"></div>
      <div class="columns is-mobile is-gapless is-multiline" style="margin-bottom:0.5rem;">
        <video v-if="is_has_movie" :src="movie_src_url" :poster="tweet_info.image[0]" controls></video>
        <div v-else class="column" v-bind:class="(tweet_info.image.length > 1) ? 'is-half':'is-full'"
             v-for="(url, idx) in tweet_info.image" :key="url">
          <div class="image is-4by3" @click="isImageModalActive=true; modal_image_idx=idx">
            <img :src="url" alt="tweet image" style="object-fit: cover;">
          </div>
        </div>
      </div>
      <a :href="ogpInfoObj.url">
        <div class="card" style="margin-bottom: 0.5em;" v-if="hasOGP">
          <div class="card-image">
              <img :src="ogpInfoObj.image" alt="Placeholder image">
          </div>
          <div class="content" style="padding: 0.3em; margin-left:0.5em; margin-right:0.5em;">
            {{ogpInfoObj.title}}
            <br>
            <p class="is-size-7 has-text-grey-light">{{ogpInfoObj.shorturl}}</p>
          </div>
        </div>
      </a>
      <b-icon icon="retweet" type="is-grey" size="is-small" style="margin-right: 0.2em;"></b-icon>
      <span style="margin-right: 1em;">{{tweet_info.retweet_count}}</span>
      <b-icon icon="heart" type="is-grey" size="is-small" style="margin-right: 0.2em;"></b-icon>
      <span>{{tweet_info.favorite_count}}</span>
    </div>
  </div>
  <b-modal :active.sync="isImageModalActive" ref="imgModal">
    <b-carousel :autoplay="false" v-model="modal_image_idx" @change="moveToTop">
      <b-carousel-item v-for="url in tweet_info.image" :key="url">
         <img :src="url" alt="tweet image">
      </b-carousel-item>
    </b-carousel>
  </b-modal>
</div>
</template>

<script>
import {addHtmlTags, extractURL} from '@/util/html_parse_util.js'

export default {
  data() {
    return{
      isImageModalActive: false,
      modal_image_idx: 0,
      ogpInfoObj: {
        title: "webサイト",
        image: "image_url",
        url: "web_url",
        shorturl: "web_u...",
      },
      hasOGP: false,
      tweet_text: ""
    }
  },
  props: {
    tweet_info: Object,
    /* tweet_infoは下記のようなjson
      {
        id: '1275411358423453696',
        text: '絶望的に弱そうな名前になってる https://t.co/aOW0nGTHdP',
        retweet_count: 0,
        favorite_count: 3,
        image: [ 'http://pbs.twimg.com/media/EbMraLaUYAIQBGx.jpg' ],
        movie: '',
        urls: [],
        user: {
          id: '2186354910',
          name: 'おりがみ',
          screen_name: 'Simulacran',
          icon: 'http://pbs.twimg.com/profile_images/679207671296208896/YL6X8oun_normal.jpg'
        }
      }
    */
  },
  created() {
    let tweetText = this.tweet_info.text
    let containURLs = extractURL(tweetText)
    const isHasMedia = this.is_has_movie || (this.tweet_info.image.length>0)
    if(isHasMedia){
      const deleteURL = containURLs.pop()
      tweetText = tweetText.replace(deleteURL, "")  // 画像付きツイートには謎のurlが末尾につくので削除する
    }
    if(containURLs.length > 0 && !isHasMedia){
      this.$store.dispatch('getOGPInfo', containURLs[0]).then((ogpInfo)=>{
        if(ogpInfo.title == undefined) return
        this.ogpInfoObj = ogpInfo
        if(ogpInfo.url.length > 40){
          this.ogpInfoObj.shorturl =  ogpInfo.url.substr(0, 40) + '…'
        }
        else{
          this.ogpInfoObj.shorturl = ogpInfo.url
        }
        this.hasOGP = true
      })
    }
    this.tweet_text = addHtmlTags(tweetText)
  },
  computed: {
    is_has_movie() {
      if(("movie" in this.tweet_info)==false) return false
      return this.tweet_info.movie != ""
    },
    movie_src_url() {
      if(this.is_has_movie == false) return ""
      return this.tweet_info.movie[this.tweet_info.movie.length-1]
    },
  },
  methods: {
    moveToTop() {
      // 画面モーダル移動時にスクロールを一番上に移動させる
      // 画像は通常上から見たいので
      this.$refs.imgModal.$el.querySelector(".modal-content").scrollTop = 0
    }
  }
}
</script>

<style lang="scss">
.tweettext {
  word-wrap:break-word
}
</style>